/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * biva.all.js
 * @author Mitsutoshi Nakamura <mitsutoshi.nakamura.jp@gmail.com>
 */

var stellarnav = __webpack_require__(1);

var App = function App() {
  _classCallCheck(this, App);

  console.log('biva.all.js');
  stellarnav.mobileCloseOnTransition();
};

$(function () {
  var app = new App();
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * _stellarnav.js
 * StellarNav1.0.0のカスタマイズ
 * @author Mitsutoshi Nakamura <mitsutoshi.nakamura.jp@gmail.com>
 */

var StellarNav = function () {
  function StellarNav() {
    _classCallCheck(this, StellarNav);
  }

  _createClass(StellarNav, [{
    key: 'mobileCloseOnTransition',

    /**
     * リンククリックで画面遷移時にメニューを初期状態に戻す
     * @return void
     */
    value: function mobileCloseOnTransition() {
      // デスクトップの場合はスルー
      if (!$('nav#main-nav').hasClass('mobile')) {
        return;
      }

      $('nav#main-nav ul a').not('.dd-toggle').on('touchstart', function (e) {
        var target = e.currentTarget;

        location.href = $(target).attr('href');
        $('nav#main-nav > ul > li.open > a.dd-toggle').trigger('click');
        $('nav#main-nav > a.menu-toggle').trigger('click');

        return false;
      });
    }
  }]);

  return StellarNav;
}();

module.exports = new StellarNav();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/js/biva.all.js